/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */

import Title from '@/components/Title';
import Image from 'next/image';
import cls from 'classnames';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
// import useIsMobile from '@/hooks/useIsMobile';
import { Pagination, Navigation, Autoplay } from 'swiper';
import TPLink from '@/components/TPLink';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useRef, useContext } from 'react';
import { MyContext } from '@/config/context-manager';
import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import useIsMobileNew from '@/hooks/useIsMobileNew';
import useIsMediumScreen from '@/hooks/useIsMediumScreen';
import useIsMaxScreen from '@/hooks/useIsMaxScreen';
import styles from './style.module.scss';

const PublicPraise = () => {
  const isSmallScreen = useIsMobileNew();
  const isMediumScreen = useIsMediumScreen();
  const isMaxScreen = useIsMaxScreen();

  const { t } = useTranslation(['chinese']);
  const { locale } = useContext(MyContext);
  const isEn = locale === 'en';
  //   const isMobile = useIsMobile();
  const swiperRef = useRef<SwiperRef['swiper']>();
  const list = [
    {
      name: t('口碑之选-学生1-姓名'),
      country: t('口碑之选-学生1-国家'),
      age: t('口碑之选-学生1-年龄'),
      level: t('口碑之选-学生1-级别'),
      words: t('口碑之选-学生1-祝福'),
      flag: '/images/chinese/public-praise-country-1.png',
      cover: '/images/chinese/public-praise-card1.png',
      coverM: '/images/chinese/public-praise-card1-m.png',
    },
    {
      name: t('口碑之选-学生2-姓名'),
      country: t('口碑之选-学生2-国家'),
      age: t('口碑之选-学生2-年龄'),
      level: t('口碑之选-学生2-级别'),
      words: t('口碑之选-学生2-祝福'),
      flag: '/images/chinese/public-praise-country-2.png',
      cover: '/images/chinese/public-praise-card2.png',
      coverM: '/images/chinese/public-praise-card3-m.png',
    },
    {
      name: t('口碑之选-学生3-姓名'),
      country: t('口碑之选-学生3-国家'),
      age: t('口碑之选-学生3-年龄'),
      level: t('口碑之选-学生3-级别'),
      words: t('口碑之选-学生3-祝福'),
      flag: '/images/chinese/public-praise-country-3.png',
      cover: '/images/chinese/public-praise-card3.png',
      coverM: '/images/chinese/public-praise-card2-m.png',
    },
  ];

  return (
    <div className="mt-5rem mx-auto mt-[80px] lg:mt-[130px] xl:mt-[46px]">
      <div className="container">
        <Title className={isSmallScreen ? '[&_strong]:inline' : ''} innerHTML theme="red">
          {isSmallScreen ? t('口碑之选-标题-M') : t('口碑之选-标题')}
        </Title>
      </div>
      <div className="flex justify-center">
        <TPLink className="relative mt-[24px] flex items-center justify-center text-xs lg:mt-10  lg:justify-start lg:text-sm xl:text-xl">
          <MaxAndMediumScreen>
            <span className=" lg:h-5 lg:w-[21px] xl:h-[30px] xl:w-[30px]">
              <Image alt="WuKong userReviews" width={30} height={30} src="/images/chinese/publicPraise-star.png" />
            </span>
          </MaxAndMediumScreen>
          <span className="ml-2 mr-5 text-[#1b1b21] lg:ml-[6px] lg:mr-4 xl:ml-2 xl:mr-5">Trustpilot</span>
          <span className="h-[14px] w-[81px] lg:h-4 lg:w-[92px] xl:h-[20px] xl:w-[115px]">
            <Image alt="WuKong userReviews" width={115} height={20} src="/images/home/userReviews-tp2.jpg" />
          </span>
          <span
            className="ml-5 text-[12px] font-[500] lg:ml-4 lg:text-[16px]"
            dangerouslySetInnerHTML={{ __html: t('用户评价-tp-1') }}
          />
          <div className="absolute hidden lg:bottom-[-5px] lg:right-[-60px] lg:block lg:h-[40px] lg:w-[40px] xl:bottom-[-10px] xl:right-[-120px] xl:block xl:h-[57px] xl:w-[57px]">
            <Image
              className="h-auto w-full"
              sizes="100vw"
              width={0}
              height={0}
              src="/images/chinese/cup-icon.png"
              alt="WuKong"
            />
          </div>
        </TPLink>
      </div>
      <div className="hidden lg:block xl:mb-[60px] xl:mt-[60px] xl:block">
        <Swiper
          className={cls(
            styles.swiper,
            'absolute !p-[20px]',
            isMaxScreen && styles.large,
            isMediumScreen && styles.default,
          )}
          slidesPerView="auto"
          centeredSlides
          spaceBetween={20}
          loop
          onInit={(swiper: SwiperRef['swiper']) => {
            swiperRef.current = swiper;
          }}
          speed={2500}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Navigation, Autoplay]}
          pagination={{
            clickable: true,
          }}
        >
          {list.map(({ name, country, age, level, words, cover, flag }, index) => {
            return (
              <SwiperSlide
                key={name}
                className="rounded-[36px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:!w-[640px] xl:!w-[880px]"
              >
                <div className="rounded-10 flex justify-between bg-[#fff] shadow-wk1 lg:rounded-[24px] lg:p-7 xl:rounded-[36px] xl:p-10">
                  <div className="overflow-hidden lg:h-[175px] lg:w-[160px] lg:rounded-[11px] xl:h-[240px] xl:w-[220px] xl:rounded-[24px]">
                    <Image src={cover} width={220} height={240} layout="responsive" alt={t('口碑之选-alt')} />
                  </div>
                  <div className={cls(' relative text-left lg:w-[380px] xl:w-[480px]', isEn && 'xl:w-[500px]')}>
                    <div
                      className={cls(
                        'absolute lg:left-[-24px] lg:top-[28px] lg:h-[20px] lg:w-[20px] xl:left-[-36px] xl:top-[50px] xl:h-[28px] xl:w-[28px]',
                        isEn && ' [&]:lg:top-[3px]  [&]:xl:top-[17px]',
                      )}
                    >
                      <Image
                        className="rounded-[12px]"
                        src="/images/chinese/publicPraise-icon.png"
                        width={28}
                        height={28}
                        layout="responsive"
                        alt="WuKong"
                      />
                    </div>
                    <h3
                      className={cls(
                        'text-wk-words-1 lg:pb-[31px] lg:pt-[24px] lg:text-[18px] lg:leading-[32px] xl:pb-[36px] xl:pt-[52px] xl:text-[20px]',
                        isEn &&
                          'lg:h-[130px] lg:pb-[11px] xl:h-[180px] [&]:lg:pt-[0px] [&]:lg:text-[16px] [&]:lg:leading-[24px] [&]:xl:pt-[12px] [&]:xl:leading-8',
                        index === 0 && '[&]:lg:pb-[11px] [&]:xl:pb-[31px]',
                      )}
                    >
                      {words}
                    </h3>
                    <div className={cls('flex lg:items-center', isEn && ' flex-wrap')}>
                      <span
                        className={cls(
                          'text-[20px] font-bold text-wk-words-1 lg:text-[16px]',
                          isEn && 'block lg:text-[16px]',
                        )}
                      >
                        {name}
                      </span>
                      <span
                        className={cls(
                          'mx-[12px] block h-[16px] w-[1px] bg-[#8D8FA6] leading-[22px]',
                          isEn && 'hidden lg:block xl:block',
                        )}
                      />
                      <span className="flex items-center text-[16px] font-[500] text-wk-words-1">
                        {country}
                        <div className=" ml-[2px] xl:h-[14px] xl:w-[19px]">
                          <Image src={flag} width={19} height={14} layout="responsive" alt="WuKong" />
                        </div>
                      </span>
                      <span
                        className={cls(
                          'mx-[12px] block h-[16px] w-[1px] bg-[#8D8FA6] leading-[22px]',
                          isEn && 'mt-[0]',
                        )}
                      />
                      <span
                        className="text-[16px] font-[500] text-wk-words-1"
                        dangerouslySetInnerHTML={{ __html: t(age) }}
                      />
                      <span
                        className={cls(
                          'mx-[12px] block h-[16px] w-[1px] bg-[#8D8FA6] leading-[22px]',
                          isEn && 'mt-[0]',
                        )}
                      />
                      <span className="text-[16px] font-[500] text-wk-words-1">{level}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
          <div className="absolute left-0 top-0 z-10 h-[400px] w-[350px] bg-gradient-to-r from-[rgba(255,255,255,1)] to-[rgba(255,255,255,0)]" />
          <div className="absolute right-0 top-0 z-10 h-[400px] w-[350px] bg-gradient-to-l from-[rgba(255,255,255,1)] to-[rgba(255,255,255,0)]" />
        </Swiper>
      </div>
      <div />
      <div className="mt-[24px] lg:hidden xl:mb-[60px] xl:mt-[60px] xl:hidden">
        <Swiper className="!pl-[20px] lg:!pl-0 xl:!p-[20px] xl:!pl-0" slidesPerView="auto" loop>
          {list.map((student, index) => {
            return (
              <SwiperSlide key={index} className="!w-[280px] pb-[.13rem] xl:!w-[880px] xl:rounded-[36px]">
                <div className="relative mr-[24px]">
                  <div className="h-[190px] overflow-hidden rounded-[24px]">
                    <Image src={student.coverM} width={220} height={190} layout="responsive" alt={t('口碑之选-alt')} />
                  </div>
                  <div className="relative bottom-[2em] z-10 rounded-3xl bg-white p-5 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]">
                    <p className="flex items-center xl:mb-[16px] xl:text-[24px] xl:text-wk-words-1">
                      <span className="font-extrabold lg:text-[20px] lg:font-semibold xl:text-[24px] xl:text-wk-words-1">
                        {student.name}
                      </span>
                    </p>
                    <p className="mt-2 flex flex-wrap items-center text-[14px] font-normal xl:mb-[24px] xl:text-[16px] xl:text-wk-words-1">
                      <span className="flex shrink-0">{student.country}</span>
                      <img className="ml-[4px] h-5 w-[19px]" src={student.flag} alt="" />
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      <span>{student.age}</span>
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      {student.level}
                    </p>
                    <h3 className="mb-4 mt-4 text-base font-normal text-wk-words-1">{student.words}</h3>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div />
    </div>
  );
};

export default PublicPraise;
